import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "全部漫画", to: "/category" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-sm"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
            <i className="ri-book-open-line"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950">
            喵趣漫画
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => {
            const active =
              item.to === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.to);
            return (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={`text-sm whitespace-nowrap transition-colors ${
                    active
                      ? "text-primary-600 font-medium"
                      : "text-foreground-700 hover:text-primary-600"
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center gap-2">
          <button
            onClick={() => window.REACT_APP_NAVIGATE("/category")}
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-5 py-2 whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-search-line"></i>
            开始看漫画
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-900 cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 pb-5 pt-3">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="block rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <button
            onClick={() => window.REACT_APP_NAVIGATE("/category")}
            className="mt-3 w-full rounded-full bg-primary-500 text-background-50 text-sm py-2.5 whitespace-nowrap cursor-pointer"
          >
            开始看漫画
          </button>
        </div>
      )}
    </header>
  );
}